<ng-content />

@if (feedback(); as kind) {
  <div class="hd-card-feedback-overlay" aria-hidden="true" [attr.data-feedback]="kind">
    <span class="hd-card-feedback-circle">
      <i
        class="hd-card-feedback-icon"
        [class.fa-solid]="true"
        [class.fa-check]="kind === 'correct'"
        [class.fa-xmark]="kind === 'wrong'"
      ></i>
    </span>
  </div>
}
